// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__Ht1FY","listPartner":"styles_listPartner__tnLKL"};